// @ vendor
const React = require('react');
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ ../../../components
const { InsuranceRequestWizard } = require('../../../components/insuranceRequestWizard/insuranceRequestWizard');

const InsuranceRequestHomeView = () => {
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-insurances'),
            url: '/myprofile/insurances'
        },
        {
            text: formatText('insuranceRequestHome-breadcrumb')
        }
    ];

    return (
        <div className="insurance-request-home-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('insuranceRequestHome-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-12">
                            <InsuranceRequestWizard />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

module.exports = InsuranceRequestHomeView;
